import React from "react"
import { Card, Avatar, Flex } from "antd"
import { EllipsisOutlined } from "@ant-design/icons"
import styles from "./mobileStaffTable.module.css"
import { Text } from "ui/Typography"
import IconWithBg from "ui/IconWithBg"

const MobileStaffTable = ({ staff }) => (
  <>
    {staff.map((member) => (
      <Card key={member.id} className={styles.card} bodyStyle={{ padding: 16 }}>
        <Flex align="center" justify="space-between" gap={16} className="w-full">
          <Flex gap={16}>
            <Avatar src={member.avatar} className={styles.avatar} />
            <Flex wrap vertical gap={4} className={styles.infoContainer}>
              <Flex wrap align="center" gap={8}>
                <Text className={styles.name}>{member.name}</Text>
                <Text className={styles.status}>{member.status}</Text>
                <Text className={styles.role}>{member.role}</Text>
              </Flex>
              <Flex align="center" gap={8} wrap className={styles.infoRow}>
                <Text className={styles.info}>{member.title}</Text>
                <div className={styles.dot} />
                <Text className={styles.info}>{member.phone}</Text>
                <div className={styles.dot} />
                <Text className={styles.info}>{member.email}</Text>
              </Flex>
            </Flex>
          </Flex>
          <IconWithBg size={32} bgColor="surface-2">
            <EllipsisOutlined />
          </IconWithBg>
        </Flex>
      </Card>
    ))}
  </>
)

export default MobileStaffTable
